import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getPreInvoices({ commit, state }) {
    commit('toggleLoading', true);

    const newFilters = { ...state.form, ...state.pagination };
    return GraphQlClient.query(`
      query (
        $warehouses: [Int]
        $delivery_methods: [Int]
        $logistic_providers: [Int]
        $status: [String]
        $margin_status: String
        $difference: String
        $date_range: DateRangeInput
        $search_by: String!
        $search_values: [String]
        $page: Int
        $limit: Int
      ) {
        preInvoicesV2(
          warehouses: $warehouses
          delivery_methods: $delivery_methods
          logistic_providers: $logistic_providers
          status: $status
          margin_status: $margin_status
          difference: $difference
          date_range: $date_range
          search_by: $search_by
          search_values: $search_values
          page: $page
          limit: $limit
        ) {
          total,
          hasNextPage,
          items {
            id
            order_number
            cte {
              number
              serie
              key
            }
            invoice {
              number
              serie
              key
              value
            }
            status
            margin_status
            tms_value
            cte_value
            payment_type
            payment_custom_value
            payment_custom_description
          }
        }
      }`, newFilters)
      .then(({ data }) => {
        const { preInvoicesV2 = {} } = data || {};
        const { items = [], total } = preInvoicesV2 || {};

        items.forEach((item) => {
          const {
            id,
            payment_type,
            payment_custom_value,
            payment_custom_description,
          } = item || {};

          const paymentTypes = {
            TMS: 'TMS',
            LOGISTIC_PROVIDER: 'CTE',
            OTHER: 'Outro',
          };

          commit('setFormInvoiceField', {
            id,
            payment_type: paymentTypes[payment_type] || 'TMS',
            payment_custom_value: payment_custom_value || null,
            payment_custom_description: payment_custom_description || null,
          });
        });

        commit('setPreInvoices', items);
        commit('setPaginationTotal', total);
        commit('toggleLoading', false);

        return items;
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  exportToExcel({ commit, state }, filters) {
    commit('toggleLoadingExports', true);

    return GraphQlClient.query(`
      query (
        $warehouses: [Int]
        $delivery_methods: [Int]
        $logistic_providers: [Int]
        $status: [String]
        $margin_status: String
        $difference: [String]
        $date_range: DateRangeInput
        $search_by: String!
        $search_values: [String]
      ) {
        exportPreInvoices(
          warehouses: $warehouses
          delivery_methods: $delivery_methods
          logistic_providers: $logistic_providers
          status: $status
          margin_status: $margin_status
          difference: $difference
          date_range: $date_range
          search_by: $search_by
          search_values: $search_values
        ) {
          ok
        }
      }`, filters)
      .then(() => {
        commit('toggleLoadingExports', false);
      })
      .catch(() => commit('toggleLoadingExports', false));
  },
  sendPreInvoice({ commit }, selectedInvoices) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation ($invoices: [CreatePreInvoicesInputType]!) {
        createPreInvoices(invoices: $invoices) {
          ok
        }
      }`, { invoices: selectedInvoices })
      .then((res) => {
        commit('toggleLoading', false);
        return res;
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/store/actions.js